import { Button as MuiButton, ButtonProps as MuiButtonProps, styled } from "@mui/material";

import { brandColors } from "../../utils/brand-colors";

const StyledButton = styled(MuiButton)(({ theme }) => {
  return {
    backgroundColor:
      theme.palette.mode === "light" ? brandColors.delete : brandColors.ceasefireWhite,
    color: theme.palette.mode === "light" ? brandColors.ceasefireWhite : "#0b1b37",
    borderRadius: "6.25rem",
    textTransform: "none",
    padding: "0.25rem 1.25rem",
    width: "fit-content",

    "&:hover": {
      backgroundColor:
        theme.palette.mode === "light"
          ? brandColors.deleteHover
          : brandColors.primaryButtonHoverDark,
    },
  };
});

interface DeleteButtonProps extends MuiButtonProps {
  children: React.ReactNode;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};

export default DeleteButton;
